import React from 'react';
import {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useEffect} from 'react';

// react-bootstrap components
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Modal,
  Col,
} from 'react-bootstrap';
import axios from '../components/Axios/Axios.js';
import DNS from '../components/DNS/dns.js';
import NotificationAlert from 'react-notification-alert';
import DNSO from '../components/DNS/dns-offline';
import {isMobile} from 'react-device-detect';
import {setUser} from '../actions/index';
import {useTranslation} from 'react-i18next';
import {translations} from '../i18n/translations';

/**
 * This function handle all the event and style in the profile page.
 * @function MyProfile
 * @return {HTML} return the profile page
*/
function MyProfile() {
  const token = useSelector((state) => state.token);
  const dispatch = useDispatch();
  const Buildings = useSelector((state) => state.building);

  const {t} = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [showEmail, setEmail] = useState('');
  const [showFname, setFname] = useState('');
  const [showLname, setLname] = useState('');
  const [showOrganization, setOrganization] = useState([]);
  const [showPassword, setPassword] = useState('');
  const [validated, setValidated] = useState(false);
  const [showApPk, setApPk] = useState('');

  const requestOptionsAxiosGet = {
    headers: {'Content-Type': 'application/json', 'Authorization': 'token ' + token['tokenRedux']},
  };

  useEffect(() => {
    getAccountInfo();
  }, []);

  const getAccountInfo = () => {
    axios.get(DNS + '/users/getUserInfo/', requestOptionsAxiosGet)
        .then((response) => {
          setEmail(response.data.email);
          setFname(response.data.firstName);
          setLname(response.data.lastName);
          setOrganization(response.data.nameEntreprise);
          setApPk(response.data.pk);
          setPassword('');
        });
  };

  const notificationAlertRef = React.useRef(null);
  const notify = (place) => {
    const type = 'success';
    let options = {};
    options = {
      place: place,
      message: (
        <div>
          <div>
            <p>{t(translations.PROFILE_MESSAGE)}</p>
          </div>
        </div>
      ),
      type: type,
      icon: 'nc-icon nc-check-2',
      autoDismiss: 7,
    };
    notificationAlertRef.current.notificationAlert(options);
  };

  const requestOptionsAxiosHeaders = {
    headers: {'Content-Type': 'application/json', 'Authorization': 'token ' + token['tokenRedux']},
  };

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    setValidated(true);
    if (form.checkValidity() === false || showEmail == '' || showLname == '' || showFname == '' || showPassword == '') {
      event.preventDefault();
      event.stopPropagation();
    } else {
      event.preventDefault();
      editAcccount();
    }
  };

  const editAcccount = () => {
    const requestOptionsAxiosPatch = {
      'email': showEmail, 'firstName': showFname, 'lastName': showLname,
      'pk': showApPk,
    };

    if (showPassword) {
      requestOptionsAxiosPatch['password'] = showPassword;
    }
    axios.patch(DNS + '/users/deleteGetPatchUser/', JSON.stringify(requestOptionsAxiosPatch), requestOptionsAxiosHeaders)
        .then((response) => {
          console.log('test');
          const requestUserInfo = {
            method: 'GET',
            headers: {'Content-Type': 'application/json', 'Authorization': 'token ' + token['tokenRedux']},
          };
          fetch(DNS + '/users/getUserInfo/', requestUserInfo)
              .then((response) => response.json())
              .then(async (data) => {
                notify('tc');
                await dispatch(setUser(data));
                window.location.replace(DNSO + '/resident/home?modify=true');
              });
        });
  };

  const DeleteAccount = () => {
    const requestOptions = {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'token ' + token['tokenRedux'],
      },
      body: JSON.stringify({pk: showApPk}),
    };
    fetch(
        DNS +
        '/users/deleteGetPatchUser/',
        requestOptions,
    ).then(async (response) => {
      dispatch(setToken(''));
      window.location.reload();
    }).catch((err) => console.log('err', err.message));
  };

  return (
    <>
      <Modal
        className="modal modal-primary"
        show={showModal}
        onHide={() => setShowModal(false)}
        onSubmit={DeleteAccount}
        autoFocus={false}
        enforceFocus={false}
      >
        <Modal.Header className="justify-content-center">
          <div className="modal-profile">
            <i className="nc-icon nc-notes"></i>
          </div>
        </Modal.Header>
        <div className="modal-body">
          <p className="text-center">{t(translations.PROFILE_MESSAGE_DELETE)}</p>
          <Form>
            <Col style={{flex: 1}}>
              <Button className="btn-fill btn-round col-sm-6" type="submit">{t(translations.DELETE)}</Button>
              <Button className="btn-fill btn-round col-sm-6" onClick={() => {
                setShowModal(false);
              }}>{t(translations.CANCEL)}</Button>
            </Col>
          </Form>
        </div>
      </Modal>
      <Container fluid>
        <Row>
          <Col md="12">
            <Card>
              <Card.Header>
                {!isMobile ?
                      <Card.Title as="h4" >{t(translations.PROFILE_SUBTITLE2) + ' :'}</Card.Title> :
                      <Card.Title as="h4" className={'text-center'}>{t(translations.PROFILE_SUBTITLE2) + ' :'}</Card.Title>
                }
              </Card.Header>
              <div className="rna-container">
                <NotificationAlert ref={notificationAlertRef}/>
              </div>
              <Card.Body className="pl-0 pr-0">
                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                  <Form>
                    <Row>
                      <Col className={'col-sm-12 col-12 col-md-12 col-lg-12'}>
                        {/* EMAIL FIELD  */}
                        <Form.Group controlId="formBasicEmail">
                          <Form.Label>{t(translations.EMAIL) + ' :'}</Form.Label>
                          <Form.Control
                            required
                            type="email"
                            placeholder={t(translations.EMAIL_PLACEHOLDER)}
                            value={showEmail}
                            onChange={(e) => {
                              setEmail(e.currentTarget.value);
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            {t(translations.EMAIL_ERROR)}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                    </Row>
                  </Form>

                  <Form>
                    <Row>
                      <Col className={'col-sm-12 col-12 col-md-6 col-lg-6'}>
                        {/* LASTNAME FIELD  */}
                        <Form.Group controlId="formBasicLastname">
                          <Form.Label>{t(translations.LASTNAME) + ' :'}</Form.Label>
                          <Form.Control
                            required
                            maxLength={30}
                            type="Lastname"
                            placeholder={t(translations.LASTNAME_PLACEHOLDER)}
                            value={showLname}
                            onChange={(e) => {
                              setLname(e.currentTarget.value);
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            {t(translations.LASTNAME_PLACEHOLDER)}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col className={'col-sm-12 col-12 col-md-6 col-lg-6'}>
                        {/* FIRSTNAME FIELD  */}
                        <Form.Group controlId="formBasicFirstname">
                          <Form.Label>{t(translations.FIRSTNAME) + ' :'}</Form.Label>
                          <Form.Control
                            required
                            maxLength={30}
                            type="firstname"
                            placeholder={t(translations.FIRSTNAME_PLACEHOLDER)}
                            value={showFname}
                            onChange={(e) => {
                              setFname(e.currentTarget.value);
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            {t(translations.FIRSTNAME_ERROR)}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Form>

                  <Form>
                    <Row>
                      <Col className={'col-sm-12 col-12 col-md-6 col-lg-6'}>
                        {/* PASSWORD FIELD  */}
                        <Form.Group controlId="formBasicPassword">
                          <Form.Label>{t(translations.PASSWORD) + ' :'}</Form.Label>
                          <Form.Control
                            required
                            type="password"
                            placeholder={t(translations.PASSWORD_PLACEHOLDER) + ' :'}
                            value={showPassword}
                            onChange={(e) => {
                              setPassword(e.currentTarget.value);
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            {t(translations.PASSWORD_ERROR)}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col className={'col-sm-12 col-12 col-md-6 col-lg-6'}>
                        {/* ORGANIZATION  */}
                        <Form.Group controlId="formBasicOrganization">
                          <Form.Label>{t(translations.COMPANY_NAME) + ' :'}</Form.Label>
                          <Form.Control required disabled type="Company" placeholder={t(translations.COMPANY_PLACEHOLDER)} value={showOrganization} onChange={(e) => {
                            setOrganization(e.currentTarget.value);
                          }} />
                        </Form.Group>
                      </Col>
                    </Row>
                  </Form>


                  <Form>
                    <Row>
                      <Col className={'col-sm-12 col-12 col-md-6 col-lg-6'}>
                        {/* ROLE  */}
                        <Form.Group controlId="formBasicOrganization">
                          <Form.Label>{t(translations.ROLE) + ' :'}</Form.Label>
                          <Form.Control disabled required value="Résident"/>
                        </Form.Group>
                      </Col>

                      <Col className={'col-sm-12 col-12 col-md-6 col-lg-6'}>
                        {/* BUILDING  */}
                        <Form.Group controlId="formBasicOrganization">
                          <Form.Label>{t(translations.BUILDING)+ ' :'}</Form.Label>
                          <Form.Control disabled required value={Buildings['buildingRedux'][0].name}/>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Form>

                  <Button className="btn-warning right mr-3" type="submit">
                    {t(translations.PROFILE_SUBTITLE2)}
                  </Button>
                  <Button className="btn-warning right mr-3" onClick={() => setShowModal(true)}>
                    {t(translations.PROFILE_SUBTITLE3)}
                  </Button>
                  <div className="clearfix"></div>
                </Form>
              </Card.Body>
              {/* <Card.Footer className="ml-auto mr-auto">*/}
              {/*    <Button className={"btn-round btn-wd"} type="submit">*/}
              {/*        Créer le compte*/}
              {/*    </Button>*/}
              {/*    <div className="clearfix"></div>*/}

              {/* </Card.Footer>*/}
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default MyProfile;
